import { render } from "./NeobuqEditModificationView.vue?vue&type=template&id=4fc1e46b&scoped=true"
import script from "./NeobuqEditModificationView.vue?vue&type=script&lang=js"
export * from "./NeobuqEditModificationView.vue?vue&type=script&lang=js"

import "./NeobuqEditModificationView.vue?vue&type=style&index=0&id=4fc1e46b&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fc1e46b"]])

export default __exports__